export const notificationType = {
    error: 'error',
    information: 'information',
    success: 'success'
};

export const notificationTarget = 'sticky-notification-target';
export const notificationTimeout = '5000';
